var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5916 15.9083L13.5 12.8417C14.7001 11.3453 15.2812 9.44608 15.124 7.53441C14.9667 5.62275 14.083 3.84398 12.6546 2.56387C11.2261 1.28375 9.36149 0.599588 7.44408 0.652055C5.52668 0.704522 3.70225 1.48963 2.34593 2.84595C0.989616 4.20227 0.204507 6.0267 0.15204 7.9441C0.0995731 9.8615 0.783736 11.7261 2.06385 13.1546C3.34397 14.5831 5.12273 15.4668 7.0344 15.624C8.94606 15.7812 10.8453 15.2001 12.3416 14L15.4083 17.0667C15.4858 17.1448 15.578 17.2068 15.6795 17.2491C15.781 17.2914 15.89 17.3132 16 17.3132C16.11 17.3132 16.2189 17.2914 16.3205 17.2491C16.422 17.2068 16.5142 17.1448 16.5916 17.0667C16.7418 16.9113 16.8258 16.7036 16.8258 16.4875C16.8258 16.2714 16.7418 16.0637 16.5916 15.9083ZM7.66665 14C6.51292 14 5.38511 13.6579 4.42582 13.0169C3.46653 12.3759 2.71886 11.4649 2.27735 10.399C1.83584 9.33308 1.72032 8.16019 1.9454 7.02864C2.17048 5.89708 2.72605 4.85768 3.54186 4.04187C4.35766 3.22607 5.39707 2.6705 6.52862 2.44542C7.66018 2.22034 8.83307 2.33585 9.89897 2.77737C10.9649 3.21888 11.8759 3.96655 12.5169 4.92584C13.1579 5.88512 13.5 7.01294 13.5 8.16666C13.5 9.71376 12.8854 11.1975 11.7914 12.2915C10.6975 13.3854 9.21374 14 7.66665 14Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.a91585a8173e430a35509677c5d0cff7.svg";
export { ForwardRef as ReactComponent };